import React  from "react";
import { RELEASE_VERSION } from '../../constants';

const ReleaseVersion = () => {
  return (
    <div className="flex w-full flex-col items-center justify-between px-1 xl:flex-row">
        <p className="mb-4 w-full text-center text-sm text-gray-900 sm:!mb-0">
          {RELEASE_VERSION}
        </p>
    </div>
  );
};

export default ReleaseVersion;
